import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import AddressForm from './AddressForm';

class AddressEdit extends Component {
  // ----------------------
  // Computed
  // ----------------------

  get isLoading() {
    return (
      this.props.isLoading.includes('updateUserAddresses') ||
      this.props.isLoadingMyProfile.includes('updateMyProfileAddresses') ||
      this.props.isLoadingMyDepartment.includes('updateMyDepartmentAddresses')
    );
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <AddressForm
          initialValues={this.props.address}
          isLoading={this.isLoading}
          onSave={formData => this.props.onSave(formData)}
        />
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isLoading: state.users.isLoading,
    isLoadingMyProfile: state.myProfile.isLoading,
    isLoadingMyDepartment: state.myDepartment.isLoading,
  };
};

export default connect(mapStateToProps, null)(AddressEdit);
